// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"efc8438e","361":"dae64264","511":"ff2db798","767":"ad329ef7"}[chunkId] + ".chunk.js";
};